import React, { useState } from 'react'
import styled from 'styled-components'
import DateDetails from '../components/AssignmentsWeekView/DateDetails'
import { RowFlexDiv } from '../components/Common/CommonStyle'
import AssignmentHeader from '../components/Common/DateComponent/AssignmentHeader'

const WeekView = ({ rightNavbarVisible, setRightNavbarVisible }) => {
  const [selectedDate, setSelectedDate] = useState(1)
  const [calendarView, setCalendarView] = React.useState(false)

  setRightNavbarVisible(true) // as rightNavbar is nomore in assignmentExpandedView

  return (
    <Wrapper>
      {/* <RowFlexDiv width='48%' backgroundColor='#fc0000'> */}
      <AssignmentHeader
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        calendarView={calendarView}
        setCalendarView={setCalendarView}
      />
      {/* </RowFlexDiv> */}

      <DateDetails
        calendarView={calendarView}
        setCalendarView={setCalendarView}
      />
    </Wrapper>
  )
}

export default WeekView

const Wrapper = styled.div`
  /* display: flex;
  gap: 30px;
  height: 100%;
  width: 100%;
  padding: 2%;
  box-sizing: border-box;
  overflow: hidden;
  overflow-y: hidden;
  overflow-x: hidden;
  flex-direction: column;
  align-items: center;

  justify-content: flex-start;
  background-color: #123456; */
  display: flex;
  /* height: 200vh; */
  gap: 10px;
  position: absolute;
  /* margin-top: 2%; */
  /* padding: 2% 2% 0 2%; */
  padding: 2%;
  /* overflow: hidden; */
  /* overflow-y: hidden; */
  /* overflow-x: hidden; */
  background-color: #fbfbfb;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
`
